import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ImageBlockComponent } from '../image-block/image-block.component';
import { TimelineImageComponent } from '../timeline-image/timeline-image.component';
import { DescriptiveTextComponent } from '../descriptive-text/descriptive-text.component';
import { CampaignLottieComponent } from '../campaign-lottie/campaign-lottie.component';
import { IframeComponent } from '../iframe/iframe.component';
import { TutorialComponent } from '../tutorial/tutorial.component';
import { KebabCasePipe } from '@finder/shared/utils/pipes/kebab-case/kebab-case.pipe';

@Component({
    selector: 'finder-carousel-content-renderer',
    templateUrl: './carousel-content-renderer.component.html',
    styleUrls: ['./carousel-content-renderer.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ImageBlockComponent,
        TimelineImageComponent,
        DescriptiveTextComponent,
        CampaignLottieComponent,
        IframeComponent,
        TutorialComponent,
        KebabCasePipe,
    ]
})
export class CarouselContentRendererComponent {
    @Input() blocks: any[];

    constructor() {}
}
